import { createSearchApiClient } from './searchApiClient';
import { type SearchFilters } from './types';

export const searchAPIClient = createSearchApiClient<SearchFilters>({});
